import { render, staticRenderFns } from "./urgeDialog.vue?vue&type=template&id=61f0bd00&scoped=true"
import script from "./urgeDialog.vue?vue&type=script&lang=js"
export * from "./urgeDialog.vue?vue&type=script&lang=js"
import style0 from "./urgeDialog.vue?vue&type=style&index=0&id=61f0bd00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0bd00",
  null
  
)

export default component.exports